import { CHATBOT } from '@/utils/constants';
import jwt from 'jwt-decode';
import storage from '@npm/key-storage';

export const tokenApp = (name = 'tokenIvr') => {
  try {
    const token = storage.get(name);
    const data = jwt(token);
    return data.app;
  } catch {
    return '';
  }
};

const chatbotMiddleware = (to, from, next) => {
  try {
    const toChatbot = to.name.toLowerCase().includes(CHATBOT);
    if (toChatbot) {
      next();
      return;
    }

    const fromChatbot = from.name && from.name.toLowerCase().includes(CHATBOT);
    const chatbotToken = tokenApp() === CHATBOT;

    if (!(chatbotToken || fromChatbot)) {
      next();
      return;
    }

    const toError404 = to.name === 'Error404';

    if (toError404) {
      next();
      return;
    }

    const isHome = from.name === 'SetNumber' || (to.path === '/' && !from.name);

    if (!isHome) {
      next({
        name: `Chatbot${to.name}`,
        query: to.query,
        params: to.params
      });
      return;
    }

    next();
  } catch {
    next();
  }
};

export default chatbotMiddleware;
